"use client";

import usePageTracking from "@/hooks/usePageTracking";

export default function PageTrackingProvider() {
  usePageTracking();

  return null;
}
